import { UIMessage } from "ai";

export const AI_ASSISTANT_FILE_URL_PREFIX = "skailer-file:";

export interface ApiAiAssistantThread {
  id: number;
  title: string;
  datetime_last_message: Date;
}

export type AiAssistantUIMessage = UIMessage<unknown, { thread: { id: number } }>;

export enum ApiAiAssistantReplyStatus {
  generating = "generating",
  done = "done",
  stopped = "stopped",
  interrupted = "interrupted",
  error = "error",
}

export interface ApiAiAssistantThreadFull {
  reply_status: ApiAiAssistantReplyStatus;
  messages: AiAssistantUIMessage[];
}
